import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

const ResidentialIcon = ({ sx, ...props }: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      sx={{
        height: '24px !important',
        width: '24px !important',
        fill: 'none',
        ...sx,
      }}
      {...props}
    >
      <g clipPath="url(#clip0_1248_2040)">
        <path
          d="M23.6 23.2H21.9753C21.9923 23.0686 22 22.9344 22 22.8C22 21.671 21.3503 20.71 20.4 20.2649V6.80003C20.4 6.56003 20.2401 6.40004 20.0001 6.40004H14.0001V0.400045C14.0001 0.160045 13.8401 6.10455e-05 13.6001 6.10455e-05H2.80008C2.55998 1.41705e-05 2.4 0.159999 2.4 0.399999V23.2H0.399984C0.159984 23.2 0 23.36 0 23.6C0 23.84 0.159984 24 0.399984 24H2.79998H3.99998H13.6H21.48H23.6C23.84 24 24 23.84 24 23.6C24 23.36 23.84 23.2 23.6 23.2ZM19.6 20.0282C19.4694 20.01 19.336 20 19.2 20C18.898 20 18.6018 20.0514 18.322 20.1475C18.2523 20.0546 18.1399 20 18 20C17.76 20 17.6 20.16 17.6 20.4V20.5225C17.4484 20.6318 17.3075 20.7564 17.1795 20.8949C17.1593 20.9162 17.1395 20.9379 17.12 20.9599C16.7886 20.5456 16.3616 20.2459 15.8789 20.1C15.8096 20.0364 15.714 19.9999 15.6 19.9999C15.5554 19.9999 15.5136 20.0055 15.475 20.0161C15.3847 20.0055 15.293 19.9999 15.2 19.9999C14.9493 19.9999 14.667 20.0325 14.4383 20.1253C14.41 20.1349 14.3819 20.1447 14.3541 20.1553C14.0776 19.9306 13.7543 19.7688 13.4137 19.6798C13.41 19.6788 13.4063 19.6781 13.4028 19.6771C13.3731 19.6695 13.3433 19.6622 13.3133 19.6557C13.289 19.6503 13.2645 19.6457 13.2399 19.6411C13.2293 19.6391 13.2187 19.637 13.208 19.6352C13.1822 19.6307 13.1564 19.6268 13.1304 19.6232C13.1188 19.6216 13.1071 19.6201 13.0955 19.6187C13.0716 19.6157 13.0477 19.6129 13.0236 19.6107C13.006 19.6091 12.9884 19.6079 12.9707 19.6066C12.9519 19.6053 12.9331 19.6037 12.9141 19.6029C12.8761 19.601 12.8381 19.5999 12.8 19.5999C12.7706 19.5999 12.7414 19.6005 12.7123 19.6016C12.6933 19.6022 12.6743 19.6034 12.6553 19.6045C12.6477 19.605 12.64 19.6053 12.6324 19.6058C12.268 19.63 11.91 19.7328 11.6 19.915V7.20001H13.6H19.6V20.0282ZM3.20002 0.80003H13.2V6.40004H11.2C10.96 6.40004 10.8 6.56003 10.8 6.80003V19.24C10.5956 19.0356 10.3599 18.8627 10.1034 18.7274C10.0808 18.7153 10.0579 18.7036 10.0349 18.6921C10.0259 18.6877 10.0169 18.683 10.0078 18.6787C9.72234 18.5402 9.4117 18.4494 9.08709 18.4154C9.08255 18.4149 9.07795 18.4145 9.07336 18.4141C9.03567 18.4103 8.9978 18.4074 8.95973 18.4052C8.94966 18.4045 8.93958 18.4039 8.92945 18.4034C8.88647 18.4014 8.84334 18.4 8.79998 18.4C8.20467 18.4 7.65314 18.5958 7.2 18.9249V18.8001C7.2 18.5601 7.04002 18.4001 6.80002 18.4001C6.56002 18.4001 6.40003 18.5601 6.40003 18.8001V19.6001C6.40003 19.6601 6.41002 19.7151 6.42877 19.7638C6.23236 20.0875 6.09703 20.4524 6.04003 20.8401C5.57953 20.8928 5.15845 21.0585 4.80005 21.3062V21.2001C4.80005 20.9601 4.64006 20.8001 4.40006 20.8001C4.16006 20.8001 4.00008 20.9601 4.00008 21.2001V22.0001C4.00008 22.0468 4.00631 22.0904 4.01784 22.1304C3.81952 22.4512 3.68456 22.8141 3.62897 23.2001H3.20011V0.80003H3.20002ZM6.21797 21.6083C6.22589 21.6076 6.23391 21.6071 6.24188 21.6065C6.26297 21.6049 6.28406 21.6033 6.30534 21.6023C6.3367 21.6009 6.36825 21.6 6.40003 21.6C6.64003 21.6 6.80002 21.44 6.80002 21.2C6.80002 20.08 7.68 19.2 8.80003 19.2C9.80002 19.2 10.64 19.92 10.76 20.92C10.7871 21.0281 10.8513 21.1173 10.9391 21.1765C10.9447 21.1804 10.9503 21.1841 10.9561 21.1877C10.9623 21.1915 10.9684 21.1953 10.9748 21.1988C10.9896 21.207 11.005 21.2144 11.021 21.2208C11.0216 21.2211 11.0222 21.2213 11.0228 21.2216C11.0411 21.2289 11.0603 21.235 11.08 21.24C11.08 21.24 11.08 21.24 11.0801 21.24C11.1039 21.2479 11.1309 21.251 11.1595 21.2501C11.291 21.252 11.4133 21.1801 11.48 21.0801C11.48 21.0801 11.4801 21.0801 11.4801 21.08L11.5201 21.04C11.8401 20.6401 12.2801 20.4001 12.8001 20.4001C13.0702 20.4001 13.3402 20.4757 13.5825 20.6172C13.1053 21.0658 12.8347 21.6507 12.8033 22.2765C12.8012 22.3174 12.8001 22.3586 12.8001 22.4001C12.8001 22.6782 12.8464 22.9448 12.9379 23.2001H4.44C4.62722 22.3389 5.34019 21.688 6.21797 21.6083ZM13.8822 23.2C13.7294 22.9415 13.64 22.636 13.64 22.36C13.64 21.9177 13.8144 21.5192 14.1141 21.2279C14.1714 21.1748 14.2325 21.1258 14.297 21.0814C14.3595 21.0819 14.4223 21.0688 14.48 21.04C15.36 20.56 16.4 21 16.72 21.88C16.76 22 16.88 22.12 17.08 22.12C17.118 22.12 17.16 22.1079 17.2022 22.0864C17.3025 22.07 17.3819 21.9963 17.44 21.88C17.595 21.5506 17.835 21.2876 18.1272 21.1033C18.1902 21.0857 18.2444 21.0546 18.2874 21.0123C18.5622 20.8742 18.8736 20.8 19.2 20.8C20.32 20.8 21.2001 21.68 21.2001 22.8C21.2001 22.92 21.2001 23.08 21.1601 23.2H13.8822Z"
          fill="#21364B"
        />
        <path
          d="M13.2 10.4C12.96 10.4 12.8 10.56 12.8 10.8V11.6C12.8 11.84 12.96 12 13.2 12C13.44 12 13.6 11.84 13.6 11.6V10.8C13.6 10.56 13.44 10.4 13.2 10.4Z"
          fill="#21364B"
        />
        <path
          d="M13.2 17.6C12.96 17.6 12.8 17.76 12.8 18V18.8C12.8 19.04 12.96 19.2 13.2 19.2C13.44 19.2 13.6 19.04 13.6 18.8V18C13.6 17.76 13.44 17.6 13.2 17.6Z"
          fill="#21364B"
        />
        <path
          d="M13.2 12.8C12.96 12.8 12.8 12.96 12.8 13.2V14C12.8 14.24 12.96 14.4 13.2 14.4C13.44 14.4 13.6 14.24 13.6 14V13.2C13.6 12.96 13.44 12.8 13.2 12.8Z"
          fill="#21364B"
        />
        <path
          d="M13.2 15.2C12.96 15.2 12.8 15.36 12.8 15.6V16.4C12.8 16.64 12.96 16.8 13.2 16.8C13.44 16.8 13.6 16.64 13.6 16.4V15.6C13.6 15.36 13.44 15.2 13.2 15.2Z"
          fill="#21364B"
        />
        <path
          d="M13.2 8C12.96 8 12.8 8.15998 12.8 8.39998V9.2C12.8 9.44 12.96 9.59998 13.2 9.59998C13.44 9.59998 13.6 9.44 13.6 9.2V8.39998C13.6 8.15998 13.44 8 13.2 8Z"
          fill="#21364B"
        />
        <path
          d="M15.6 12C15.84 12 16 11.84 16 11.6V10.8C16 10.56 15.84 10.4 15.6 10.4C15.36 10.4 15.2 10.56 15.2 10.8V11.6C15.2 11.84 15.36 12 15.6 12Z"
          fill="#21364B"
        />
        <path
          d="M15.6 9.59998C15.84 9.59998 16 9.44 16 9.2V8.39998C16 8.15998 15.84 8 15.6 8C15.36 8 15.2 8.15998 15.2 8.39998V9.2C15.2 9.44 15.36 9.59998 15.6 9.59998Z"
          fill="#21364B"
        />
        <path
          d="M15.6 14.4C15.84 14.4 16 14.24 16 14V13.2C16 12.96 15.84 12.8 15.6 12.8C15.36 12.8 15.2 12.96 15.2 13.2V14C15.2 14.24 15.36 14.4 15.6 14.4Z"
          fill="#21364B"
        />
        <path
          d="M15.6 16.8C15.84 16.8 16 16.64 16 16.4V15.6C16 15.36 15.84 15.2 15.6 15.2C15.36 15.2 15.2 15.36 15.2 15.6V16.4C15.2 16.64 15.36 16.8 15.6 16.8Z"
          fill="#21364B"
        />
        <path
          d="M15.6 19.2C15.84 19.2 16 19.04 16 18.8V18C16 17.76 15.84 17.6 15.6 17.6C15.36 17.6 15.2 17.76 15.2 18V18.8C15.2 19.04 15.36 19.2 15.6 19.2Z"
          fill="#21364B"
        />
        <path
          d="M18 14.4C18.24 14.4 18.4 14.24 18.4 14V13.2C18.4 12.96 18.24 12.8 18 12.8C17.76 12.8 17.6 12.96 17.6 13.2V14C17.6 14.24 17.76 14.4 18 14.4Z"
          fill="#21364B"
        />
        <path
          d="M18 12C18.24 12 18.4 11.84 18.4 11.6V10.8C18.4 10.56 18.24 10.4 18 10.4C17.76 10.4 17.6 10.56 17.6 10.8V11.6C17.6 11.84 17.76 12 18 12Z"
          fill="#21364B"
        />
        <path
          d="M18 19.2C18.24 19.2 18.4 19.04 18.4 18.8V18C18.4 17.76 18.24 17.6 18 17.6C17.76 17.6 17.6 17.76 17.6 18V18.8C17.6 19.04 17.76 19.2 18 19.2Z"
          fill="#21364B"
        />
        <path
          d="M18 16.8C18.24 16.8 18.4 16.64 18.4 16.4V15.6C18.4 15.36 18.24 15.2 18 15.2C17.76 15.2 17.6 15.36 17.6 15.6V16.4C17.6 16.64 17.76 16.8 18 16.8Z"
          fill="#21364B"
        />
        <path
          d="M18 9.59998C18.24 9.59998 18.4 9.44 18.4 9.2V8.39998C18.4 8.15998 18.24 8 18 8C17.76 8 17.6 8.15998 17.6 8.39998V9.2C17.6 9.44 17.76 9.59998 18 9.59998Z"
          fill="#21364B"
        />
        <path
          d="M4.40005 15.2C4.64005 15.2 4.80003 15.04 4.80003 14.8V14C4.80003 13.76 4.64005 13.6 4.40005 13.6C4.16005 13.6 4.00006 13.76 4.00006 14V14.8C4.00001 15.04 4.16005 15.2 4.40005 15.2Z"
          fill="#21364B"
        />
        <path
          d="M4.40005 17.6C4.64005 17.6 4.80003 17.44 4.80003 17.2V16.4C4.80003 16.16 4.64005 16 4.40005 16C4.16005 16 4.00006 16.16 4.00006 16.4V17.2C4.00001 17.44 4.16005 17.6 4.40005 17.6Z"
          fill="#21364B"
        />
        <path
          d="M4.40005 20C4.64005 20 4.80003 19.84 4.80003 19.6V18.8C4.80003 18.56 4.64005 18.4 4.40005 18.4C4.16005 18.4 4.00006 18.56 4.00006 18.8V19.6C4.00001 19.84 4.16005 20 4.40005 20Z"
          fill="#21364B"
        />
        <path
          d="M4.40005 3.20002C4.64005 3.20002 4.80003 3.04004 4.80003 2.80004V2.00002C4.80003 1.76002 4.64005 1.60004 4.40005 1.60004C4.16005 1.60004 4.00006 1.76002 4.00006 2.00002V2.80004C4.00001 3.03999 4.16005 3.20002 4.40005 3.20002Z"
          fill="#21364B"
        />
        <path
          d="M4.40005 5.59998C4.64005 5.59998 4.80003 5.44 4.80003 5.2V4.39998C4.80003 4.15998 4.64005 4 4.40005 4C4.16005 4 4.00006 4.15998 4.00006 4.39998V5.2C4.00001 5.43995 4.16005 5.59998 4.40005 5.59998Z"
          fill="#21364B"
        />
        <path
          d="M4.40005 8.00001C4.64005 8.00001 4.80003 7.84002 4.80003 7.60002V6.80001C4.80003 6.56001 4.64005 6.40002 4.40005 6.40002C4.16005 6.40002 4.00006 6.56001 4.00006 6.80001V7.60002C4.00001 7.83998 4.16005 8.00001 4.40005 8.00001Z"
          fill="#21364B"
        />
        <path
          d="M4.40005 10.4C4.64005 10.4 4.80003 10.24 4.80003 10V9.20003C4.80003 8.96003 4.64005 8.80005 4.40005 8.80005C4.16005 8.80005 4.00006 8.96003 4.00006 9.20003V10C4.00001 10.24 4.16005 10.4 4.40005 10.4Z"
          fill="#21364B"
        />
        <path
          d="M4.40005 12.8C4.64005 12.8 4.80003 12.64 4.80003 12.4V11.6C4.80003 11.36 4.64005 11.2 4.40005 11.2C4.16005 11.2 4.00006 11.36 4.00006 11.6V12.4C4.00001 12.64 4.16005 12.8 4.40005 12.8Z"
          fill="#21364B"
        />
        <path
          d="M6.80001 5.59998C7.04001 5.59998 7.19999 5.44 7.19999 5.2V4.39998C7.19999 4.15998 7.04001 4 6.80001 4C6.56001 4 6.40002 4.15998 6.40002 4.39998V5.2C6.39998 5.43995 6.56001 5.59998 6.80001 5.59998Z"
          fill="#21364B"
        />
        <path
          d="M6.80001 3.20002C7.04001 3.20002 7.19999 3.04004 7.19999 2.80004V2.00002C7.19999 1.76002 7.04001 1.60004 6.80001 1.60004C6.56001 1.60004 6.40002 1.76002 6.40002 2.00002V2.80004C6.39998 3.03999 6.56001 3.20002 6.80001 3.20002Z"
          fill="#21364B"
        />
        <path
          d="M6.80001 10.4C7.04001 10.4 7.19999 10.24 7.19999 10V9.20003C7.19999 8.96003 7.04001 8.80005 6.80001 8.80005C6.56001 8.80005 6.40002 8.96003 6.40002 9.20003V10C6.39998 10.24 6.56001 10.4 6.80001 10.4Z"
          fill="#21364B"
        />
        <path
          d="M6.80001 8.00001C7.04001 8.00001 7.19999 7.84002 7.19999 7.60002V6.80001C7.19999 6.56001 7.04001 6.40002 6.80001 6.40002C6.56001 6.40002 6.40002 6.56001 6.40002 6.80001V7.60002C6.39998 7.83998 6.56001 8.00001 6.80001 8.00001Z"
          fill="#21364B"
        />
        <path
          d="M6.80001 12.8C7.04001 12.8 7.19999 12.64 7.19999 12.4V11.6C7.19999 11.36 7.04001 11.2 6.80001 11.2C6.56001 11.2 6.40002 11.36 6.40002 11.6V12.4C6.39998 12.64 6.56001 12.8 6.80001 12.8Z"
          fill="#21364B"
        />
        <path
          d="M6.80001 15.2C7.04001 15.2 7.19999 15.04 7.19999 14.8V14C7.19999 13.76 7.04001 13.6 6.80001 13.6C6.56001 13.6 6.40002 13.76 6.40002 14V14.8C6.39998 15.04 6.56001 15.2 6.80001 15.2Z"
          fill="#21364B"
        />
        <path
          d="M6.80001 17.6C7.04001 17.6 7.19999 17.44 7.19999 17.2V16.4C7.19999 16.16 7.04001 16 6.80001 16C6.56001 16 6.40002 16.16 6.40002 16.4V17.2C6.39998 17.44 6.56001 17.6 6.80001 17.6Z"
          fill="#21364B"
        />
        <path
          d="M9.20003 8.00001C9.44003 8.00001 9.60002 7.84002 9.60002 7.60002V6.80001C9.60002 6.56001 9.44003 6.40002 9.20003 6.40002C8.96003 6.40002 8.80005 6.56001 8.80005 6.80001V7.60002C8.8 7.83998 8.96003 8.00001 9.20003 8.00001Z"
          fill="#21364B"
        />
        <path
          d="M9.20003 5.59998C9.44003 5.59998 9.60002 5.44 9.60002 5.2V4.39998C9.60002 4.15998 9.44003 4 9.20003 4C8.96003 4 8.80005 4.15998 8.80005 4.39998V5.2C8.8 5.43995 8.96003 5.59998 9.20003 5.59998Z"
          fill="#21364B"
        />
        <path
          d="M9.20003 3.20002C9.44003 3.20002 9.60002 3.04004 9.60002 2.80004V2.00002C9.60002 1.76002 9.44003 1.60004 9.20003 1.60004C8.96003 1.60004 8.80005 1.76002 8.80005 2.00002V2.80004C8.8 3.03999 8.96003 3.20002 9.20003 3.20002Z"
          fill="#21364B"
        />
        <path
          d="M9.20003 17.6C9.44003 17.6 9.60002 17.44 9.60002 17.2V16.4C9.60002 16.16 9.44003 16 9.20003 16C8.96003 16 8.80005 16.16 8.80005 16.4V17.2C8.8 17.44 8.96003 17.6 9.20003 17.6Z"
          fill="#21364B"
        />
        <path
          d="M9.20003 15.2C9.44003 15.2 9.60002 15.04 9.60002 14.8V14C9.60002 13.76 9.44003 13.6 9.20003 13.6C8.96003 13.6 8.80005 13.76 8.80005 14V14.8C8.8 15.04 8.96003 15.2 9.20003 15.2Z"
          fill="#21364B"
        />
        <path
          d="M9.20003 12.8C9.44003 12.8 9.60002 12.64 9.60002 12.4V11.6C9.60002 11.36 9.44003 11.2 9.20003 11.2C8.96003 11.2 8.80005 11.36 8.80005 11.6V12.4C8.8 12.64 8.96003 12.8 9.20003 12.8Z"
          fill="#21364B"
        />
        <path
          d="M9.20003 10.4C9.44003 10.4 9.60002 10.24 9.60002 10V9.20003C9.60002 8.96003 9.44003 8.80005 9.20003 8.80005C8.96003 8.80005 8.80005 8.96003 8.80005 9.20003V10C8.8 10.24 8.96003 10.4 9.20003 10.4Z"
          fill="#21364B"
        />
        <path
          d="M11.6 5.59998C11.84 5.59998 12 5.44 12 5.2V4.39998C12 4.15998 11.84 4 11.6 4C11.36 4 11.2 4.15998 11.2 4.39998V5.2C11.2 5.43995 11.36 5.59998 11.6 5.59998Z"
          fill="#21364B"
        />
        <path
          d="M11.6 3.20002C11.84 3.20002 12 3.04004 12 2.80004V2.00002C12 1.76002 11.84 1.60004 11.6 1.60004C11.36 1.60004 11.2 1.76002 11.2 2.00002V2.80004C11.2 3.03999 11.36 3.20002 11.6 3.20002Z"
          fill="#21364B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1248_2040">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default ResidentialIcon;
